<template>
	<div id="page-dashboard" class="vx-card p-8 pt-8">
    <vx-card class="w-100" :title="`利用状況【集計日:${now}】`">
      <div class="vx-row mt-4">
        <div class="vx-col w-80 flex flex-wrap items-center justify-center ">
          <label class="text-sm w-20 flex flex-wrap items-end justify-end mr-10">対象企業</label>
          <v-select class="sm:mr-4 w-20 sm:order-normal order-3 sm:mt-0 mt-4" :clearable="false" @option:selected="getUsageReport"
                    label="name" :searchable="false" :reduce="item => item.id" :options="companiesData" v-model="filter.company">
          </v-select>
        </div>
      </div>
      <div class="vx-row mt-4">
        <div class="vx-col w-80 flex flex-wrap items-center justify-center ">
          <label class="text-sm w-20 flex flex-wrap items-end justify-end mr-10">対象月</label>
          <v-select class="sm:mr-4 w-20 sm:order-normal order-3 sm:mt-0 mt-4" :clearable="false" @option:selected="getUsageReport"
                    label="name" :searchable="false" :reduce="item => item.id" :options="monthsData" v-model="filter.month">
          </v-select>
        </div>
      </div>
      <div class="vx-row mt-4" v-if="usageReport">
        <div class="vx-col w-80 flex flex-wrap items-center justify-center ">
          <label class="text-sm w-20 flex flex-wrap items-end justify-end mr-10">ユーザー数</label>
          <div class="sm:mr-4 w-20 sm:order-normal order-3 sm:mt-0 mt-4">{{parseInt(usageReport.userStatistic.total_admin) + parseInt(usageReport.userStatistic.total_user)}}人 (管理者：{{usageReport.userStatistic.total_admin}}人、　利用者：{{usageReport.userStatistic.total_user}}人)</div>
        </div>
      </div>
      <div class="vx-row mt-4" v-if="usageReport">
        <div class="vx-col w-80 flex flex-wrap items-center justify-center ">
          <label class="text-sm w-20 flex flex-wrap items-end justify-end mr-10">受信メール件数の合計</label>
          <div class="sm:mr-4 w-20 sm:order-normal order-3 sm:mt-0 mt-4">{{usageReport.totalReceivedMail}}件</div>
        </div>
      </div>
      <div class="vx-row mt-4" v-if="usageReport">
        <div class="vx-col w-80 flex flex-wrap items-center justify-center ">
          <label class="text-sm w-20 flex flex-wrap items-end justify-end mr-10">送信メール件数の合計</label>
          <div class="sm:mr-4 w-20 sm:order-normal order-3 sm:mt-0 mt-4">{{usageReport.totalSentMail}}件</div>
        </div>
      </div>
      <div class="vx-row mt-4" v-if="usageReport">
        <div class="vx-col w-80 flex flex-wrap items-center justify-center ">
          <label class="text-sm w-20 flex flex-wrap items-end justify-end mr-10">契約メールサーバ数の合計</label>
          <div class="sm:mr-4 w-20 sm:order-normal order-3 sm:mt-0 mt-4">{{usageReport.totalMailServer}}サーバ</div>
        </div>
      </div>
      <div class="vx-row mt-4" v-if="usageReport">
        <div class="vx-col w-80 flex flex-wrap items-center justify-center ">
          <label class="text-sm w-20 flex flex-wrap items-end justify-end mr-10">添付ファイル使用容量</label>
          <div class="sm:mr-4 w-20 sm:order-normal order-3 sm:mt-0 mt-4">{{formatBytes(parseInt(usageReport.attachmentSize))}}</div>
        </div>
      </div>
    </vx-card>
	</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import VxCard from '../components/vx-card/VxCard.vue';

export default {
  components: {VxCard},
	data() {
		return{
      now: this.$moment().subtract(1, 'days').format('YYYY/MM/DD'),
      filter:{
        company: null,
        month: this.$moment().format('YYYYMM')
      },
      usageReport: null
		}
	},
	methods: {
		...mapActions({
      fetchList: 'company/fetchList',
      fetchUsageReport: 'company/fetchUsageReport'
		}),
    getCompanies(){
      this.fetchList({
        orderBy: 'company_name',
        orderDir: 'asc'
      })
    },
    async getUsageReport(){
		  this.usageReport = await this.fetchUsageReport({company: this.filter.company, month: this.filter.month});
    },
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return '0 Bytes';

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + sizes[i];
    }
	},
  computed: {
    ...mapGetters({
      getCompaniesList: 'company/getCompany'
    }),
    companiesData () {
      let companiesData = [{id:null, name:'全企業'}]
      this.$store.state.company.companyList.forEach((element) => {
        companiesData.push({ id: element.id, name: element.company_name + ' ' + element.company_name_kana});
      });
      return companiesData
    },
    monthsData(){
      let now = this.$moment();
      let monthsData = [{id:now.format('YYYYMM'), name:`今月(${now.format('YYYY/MM')})`}]
      for(let i = 1; i<=12; i++){
        let month = now.subtract(1, 'months') ;
        monthsData.push({id:month.format('YYYYMM'), name:`${i}ヵ月前(${month.format('YYYY/MM')})`});
      }
      return monthsData;
    }
  },
	created (){
    this.getCompanies();
	},
	mounted () {
    this.getUsageReport();
	}
}
</script>

<style lang="scss">
</style>